<!--
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2022-04-11 17:26:46
 * @LastEditors: ws2044 a3131854594@163.com
 * @LastEditTime: 2025-06-18 10:25:20
 * @FilePath: \yk_ai_editor\src\layout\components\Sidebar\Logo.vue
 * @Description: 企业logo和名称
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->

<template>
    <div class="sidebar-logo-container" :class="{ 'collapse': collapse }">
        <transition name="sidebarLogoFade">
            <div key="collapse" class="sidebar-logo-link">
                <img :src="logo" class="sidebar-logo" id="sidebar-logo" alt="企业logo">
                <!-- <div class="sidebar-title">{{ title }}</div> -->
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'SidebarLogo',
    props: {
        collapse: {
            type: Boolean,
            required: true
        }
    },
    watch: {
        logo(value) {
            if (value) {
                this.logo = value
            }
        },
    },
    data() {
        return {
            title: localStorage.getItem('enterpriseName') != 'undefined' && localStorage.getItem('enterpriseName') ? localStorage.getItem('enterpriseName') : '--',
            logo: localStorage.getItem('logo') != 'undefined' && localStorage.getItem('logo') ? localStorage.getItem('logo') : require('@/assets/default-logo.png')
        }
    }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
    transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
    opacity: 0;
}

.sidebar-logo-container {
    position: relative;
    width: 100%;
    height: 145px;
    // background: #2b2f3a;
    text-align: center;
    overflow: hidden;

    & .sidebar-logo-link {
        height: 100%;
        width: 100%;

        & .sidebar-logo {
            width: 64px;
            margin-top: 29px;
            height: 64px;
            vertical-align: middle;
            border-radius: 10px;
            object-fit: cover;
        }

        & .sidebar-title {
            // display: inline-block;
            // width: 100%;
            margin: 0 auto;
            text-align: center;
            color: #fff;
            // font-weight: 600;
            margin-top: 15px;
            padding: 0 10px;
            box-sizing: border-box;
            line-height: 20px;
            font-size: 12px;
            font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
            vertical-align: middle;
        }
    }

    &.collapse {
        .sidebar-logo {
            margin-right: 0px;
        }
    }
}
</style>
